import { Article, Category } from '@wix/answers-api';

import { EMPTY_CATEGORY_ID } from '../constants';
import { findCategoryInTreeById } from './categories';
import { isMonthOldLaunchedFr } from './is-month-old-launched-fr';

const EXCLUDED_ARTICLE_IDS = [
  '8412d7b1-9650-4c1c-81d1-1111379c690d',
];

// The kb-server category tree excludes hidden categories together with their
// whole subtree. So when we have the tree, an article whose category is absent
// from it belongs to a hidden category and must not be indexed.
const isCategoryHidden = (
  categoryId?: string,
  categoriesTree?: Category[]
): boolean => {
  if (!categoriesTree?.length) {
    return false;
  }
  if (!categoryId || categoryId === EMPTY_CATEGORY_ID) {
    return false;
  }
  return !findCategoryInTreeById(categoriesTree, categoryId);
};

export const shouldAddNoIndex = (
  article?: Article,
  categoriesTree?: Category[]
): boolean => {
  if (!article) {
    return false;
  }

  // Check if article URL is in the excluded list
  if (article && article.id && EXCLUDED_ARTICLE_IDS.includes(article.id)) {
    return true;
  }

  // Check if it's an old feature request
  const noIndexDueToOldFR = article && isMonthOldLaunchedFr(article as any);

  // Check if excluded from help center content scope
  const isExcludedFromHelpCenter = article && article?.excludedFromHelpCenterContentScope;

  // Check if the article's category is hidden (missing from the category tree)
  const noIndexDueToHiddenCategory = isCategoryHidden(
    article.categoryId,
    categoriesTree
  );

  const visibilitySettings = (article as any)?.visibilitySettings;
  const noIndexDueToVisibilitySettings = Boolean(
    visibilitySettings?.noIndex || visibilitySettings?.hidden
  );

  return (
    (noIndexDueToOldFR ||
      isExcludedFromHelpCenter ||
      noIndexDueToHiddenCategory ||
      noIndexDueToVisibilitySettings) ??
    false
  );
};
